module.exports = __webpack_public_path__ + "img/rookerhall-h-474x356.c0d5dd36.jpg";